export default "__VITE_ASSET__CEXnKmre__"